import React from 'react';
import cs from 'classnames';
import { IconType } from './ts-config';
import styles from './index.module.less';

const IconFont: React.FC<IconType> = ({ iconHref, className, style, onClick }) => {
  return (
    <svg className={cs(styles.icon, className)} style={style} aria-hidden onClick={() => onClick && onClick()}>
      <use xlinkHref={`#${iconHref}`} />
    </svg>
  );
};

export default IconFont;
